<sco-dialog (scoDialogCloseClicked)="closeDialogClicked()">
  <ng-container headerLeft>
    <div class="dialog-header">
      <h2>{{ 'ERROR.TITLE' | translate }}</h2>
    </div>
  </ng-container>

  <div class="dialog-content">
    @if (data.status !== undefined) {
    <p>
      <strong>{{ 'ERROR.STATUS' | translate }}:</strong> {{ data.status }}
    </p>
    }
    <p>
      <strong>{{ 'ERROR.MESSAGE' | translate }}:</strong> {{ data.message }}
    </p>
  </div>

  <ng-container footerRight>
    <button scoButton (click)="close()">{{ 'ERROR.CLOSE' | translate }}</button>
  </ng-container>
</sco-dialog>
